class HHBlogMobileHeader extends HTMLElement {
  constructor() {
    super();

    this.staticHeader = this.querySelector('.js-header-blog-mobile-static')
    this.animatedHeader = this.querySelector('.js-header-blog-mobile-animated')
  }

  connectedCallback() {
    this.initObserver();
  }

  initObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      if (entries[0].isIntersecting) {
        this.classList.remove('scrolled')
      } else {
        this.classList.add('scrolled')
      }
    })

    observer.observe(this.staticHeader)
  }
}

customElements.define('hh-blog-mobile-header', HHBlogMobileHeader)